export default __webpack_public_path__ + "static/media/police_icon.f357ba88.svg";